import React from 'react'

const CoreComponent14 = ({content}) => {
  return (
     <div className='row'>
        {
          content.map((val,i)=>(
            <div key={i}  className={`${val.space? 'col-md-6  ':'col-lg-4 col-12  m-auto'} p-3     `}>
              <div  className='mb-4 m-auto bg-light  h-100 shadow-lg shadow-sm rounded-4 text-center flutter-solution-box'>
                <div className='hover-hidden-content' >

                <img src={val.icon} alt="" style={{width:200,height: val.space ? 140 :110 }} />
                <h3 className='h3-heading lh-base  fs-5 mt-lg-4 mt-3'>{val.title}</h3>
                </div>
                <div className=' hover-content-part'>
                <p className='h3-para lh-base fs-6 p-3'>{val.desc}</p>
                </div>
              </div>
            </div>
          ))
        }

      </div>
  )
}

export default CoreComponent14